import styled from 'styled-components'
import { Menu } from '@styled-icons/evaicons-solid/Menu'
import { CloseOutline } from '@styled-icons/evaicons-outline/CloseOutline'
import { Cloud } from '../HeaderSharedComponents/Cloud'

export const Main = styled.main`
  display: grid;
  grid-template-columns: 2.5fr 0fr;
  gap: 0;
  grid-template-areas:
    'logo translate highlight menu'
    'buttons buttons buttons buttons';
  background-color: ${props => props.theme.colors.white};
  padding-top: 27px;
  padding-right: 28px;
  padding-left: 28px;
  padding-bottom: 22px;
}


  @media (max-width: 767px) and (min-width: 600px) {
    grid-template-columns: 2.5fr 0fr;
  }

  @media only screen and (max-width: 320px) {
    grid-template-columns: 2.5fr 0fr;
  }
`

export const HeaderHighlightLink = styled.a`
  grid-area: highlight;
  justify-self: flex-end;
  align-self: center;
  font-size: 1.6rem;
  font-weight: bold;
  font-family: ${props => props.theme.font};
  text-decoration: none;
  color: ${props => props.theme.colors.white};
`

export const MenuButton = styled.button`
  grid-area: menu;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
`

export const MenuText = styled.p`
  color: ${props => props.theme.colors.secondary};
  font-size: 12px;
  line-height: 26px;
  padding-right: 8px;
`

export const MenuIcon = styled(Menu)`
  color: ${props => props.theme.colors.black};
`

export const MenuCloseIcon = styled(CloseOutline)`
  color: ${props => props.theme.colors.black};
`

export  const Line = styled.div`
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0px;
  top: 64px;
  background: rgba(22, 22, 22, 0.12);
`
export const LogoMenuBurger = styled(Cloud)`
  width: 29px;
  height: 19px;
  color: ${props => props.theme.header.iconDasa};
`
